import { render, staticRenderFns } from "./exam-rating-dialog.vue?vue&type=template&id=0ea87e02&scoped=true"
import script from "./exam-rating-dialog.vue?vue&type=script&lang=js"
export * from "./exam-rating-dialog.vue?vue&type=script&lang=js"
import style0 from "./exam-rating-dialog.vue?vue&type=style&index=0&id=0ea87e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea87e02",
  null
  
)

export default component.exports